import React from 'react';

const DataWindowSlider = ({ 
  aggregation,
  dataWindow, 
  maxDataLength, 
  updateWindow, 
  dateRangeText,
  windowSize = 100,
}) => {
  // Корректируем maxDataLength в зависимости от aggregation
  const adjustedMaxDataLength = aggregation === 'month' 
    ? Math.ceil(maxDataLength / 30)
    : aggregation === 'week'
    ? Math.ceil(maxDataLength / 7)
    : maxDataLength;

  const visibleCount = Math.max(0, Math.min(windowSize, adjustedMaxDataLength - dataWindow.start));
  const total = Math.max(1, adjustedMaxDataLength);
  const canScroll = adjustedMaxDataLength > windowSize;

  return (
    <div style={{ width: '100%', maxWidth: '800px', marginBottom: 8, position: 'relative' }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '8px',
        backgroundColor: '#eee',
        borderRadius: '4px'
      }}>
        <div style={{
          position: 'absolute',
          height: '100%',
          left: `${(dataWindow.start / total) * 100}%`,
          width: `${(visibleCount / total) * 100}%`,
          backgroundColor: '#1976d2',
          borderRadius: '4px',
          cursor: 'pointer'
        }} />
      </div>
      <input
        type="range"
        aria-label="Прокрутка диапазона дат графика"
        disabled={!canScroll}
        min={0}
        max={Math.max(0, adjustedMaxDataLength - windowSize)}
        step={1}
        value={dataWindow.start}
        onChange={(e) => updateWindow(e.target.value)}
        style={{
          width: '100%',
          opacity: 0,
          height: '8px',
          cursor: 'pointer',
          position: 'relative',
          zIndex: 2,
          transform: 'translate(0%,-150%)'
        }}
      />
      <div style={{ textAlign: 'center', marginTop: 1, color: '#1976d2', fontSize: 14 }}>
        {dateRangeText}
      </div>
    </div>
  );
};

export default DataWindowSlider;
